import { Observable } from 'rxjs';
import { Partnership } from '../shared/dto/partnership/partnership';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RequestService } from '../shared/services/request-service';
import { CompanyLite } from '../shared/dto/company-lite';
import { Injectable } from '@angular/core';
import { VendorLite } from '../shared/dto/vendor-management/vendor-lite';

@Injectable()
export class PartnershipService {
  constructor(
    private httpClient: HttpClient,
    private requestService: RequestService) {
  }

  public getClientPartnerVendor(companyId: number): Observable<VendorLite> {
    const url = `/api/partnership/company/${companyId}`;
    const headers: HttpHeaders = this.requestService.buildHttpHeaders();
    return this.httpClient.get<VendorLite>(url, { headers });
  }

  public getAvailablePartnerClients(vendorId: number): Observable<CompanyLite[]> {
    const url = `/api/partnership/${vendorId}/available`;
    const headers: HttpHeaders = this.requestService.buildHttpHeaders();
    return this.httpClient.get<CompanyLite[]>(url, { headers });
  }

  public getVendorPartnership(vendorId: number): Observable<Partnership> {
    const url = `/api/partnership/vendor/${vendorId}`;
    const headers: HttpHeaders = this.requestService.buildHttpHeaders();
    return this.httpClient.get<Partnership>(url, { headers });
  }

  public updatePartnership(partnership: Partnership): Observable<Partnership> {
    const url = '/api/partnership';
    const headers: HttpHeaders = this.requestService.buildHttpHeaders();
    return this.httpClient.post<Partnership>(url, partnership, { headers });
  }
}
